"use client";

import { useState } from "react";



interface Testimonial {
  id: string;
  quote: string;
  author: string;
  role: string;
  company: string;
  avatar: string;
  alt: string;
  metric?: string;
}

const TestimonialMarquee = () => {
  const [isPaused, setIsPaused] = useState(false);

  const testimonials: Testimonial[] = [
  {
    id: "testimonial_1",
    quote: "TradingHub helped us save 15% on soybean meal costs while maintaining premium quality. Their transparent pricing model is refreshing.",
    author: "Sarah Mitchell",
    role: "Procurement Director",
    company: "AgriCorp Industries",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1244494bb-1763294112072.png",
    alt: "Professional woman in business attire smiling at camera",
    metric: "15% cost savings"
  },
  {
    id: "testimonial_2",
    quote: "Fastest cement delivery in the region. Their logistics team is exceptional - we've never had a delayed shipment in 2 years.",
    author: "James Rodriguez",
    role: "Operations Manager",
    company: "BuildCo Construction",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_163fe648f-1763296122176.png",
    alt: "Professional man in construction helmet at building site",
    metric: "99.9% on-time"
  },
  {
    id: "testimonial_3",
    quote: "Our go-to supplier for industrial products for 3 years. ISO certification and quality consistency make them reliable partners.",
    author: "Michael Chen",
    role: "Supply Chain Lead",
    company: "IndustrialTech Solutions",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1078b8bc3-1763296698021.png",
    alt: "Professional man in industrial facility wearing safety vest",
    metric: "3-year partnership"
  },
  {
    id: "testimonial_4",
    quote: "Excellent grain quality and competitive pricing. Their market intelligence reports help us make better purchasing decisions.",
    author: "Emily Watson",
    role: "Head of Procurement",
    company: "FoodProcess Corp",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f6d6649d-1764637483344.png",
    alt: "Professional woman in food processing facility with clipboard",
    metric: "$2M annual volume"
  }];


  // Duplicate for seamless loop
  const allTestimonials = [...testimonials, ...testimonials];

  return null;
};

export default TestimonialMarquee;